/* eslint-disable @typescript-eslint/consistent-type-assertions */

import { setup } from 'xstate5';

import { CartHandoffActions } from './cart-handoff-machine.actions';
import { CartHandoffActors } from './cart-handoff-machine.actors';
import { CartHandoffContext, initialContext } from './cart-handoff-machine.context';
import { CartHandoffEvent } from './cart-handoff-machine.events';
import { CartHandoffGuards } from './cart-handoff-machine.guards';

// ─────────────────────────────────────────────────────────────────────────────

export const cartHandoffMachine = setup({
  types: { context: {} as CartHandoffContext, events: {} as CartHandoffEvent },
  actions: CartHandoffActions,
  guards: CartHandoffGuards,
  actors: CartHandoffActors,
}).createMachine({
  context: initialContext,
  initial: 'fetchingInitialData',
  states: {
    fetchingInitialData: {
      invoke: {
        id: 'fetchInitialData',
        src: 'fetchInitialData',
        onDone: [
          {
            target: 'activeBagWarning',
            actions: [{ type: 'storeOrderToken', params: ({ event }) => event.output }],
            guard: { type: 'checkIfWouldClearActiveBag', params: ({ event }) => event.output },
          },
          {
            target: 'cartHandoff',
            actions: [{ type: 'storeOrderToken', params: ({ event }) => event.output }],
            guard: { type: 'checkIfHasOrderToken', params: ({ event }) => event.output },
          },
          {
            target: 'dismissed',
            actions: ['dismissToHome'],
          },
        ],
      },
    },
    cartHandoff: {
      entry: ['trackHandoffStart'],
      invoke: {
        id: 'cartHandoff',
        src: 'handoffCart',
        input: ({ context }) => ({
          orderToken: context.orderToken!,
          ignoreConflicts: context.ignoreConflicts,
        }),
        onDone: [
          {
            target: 'nothingAvailable',
            guard: { type: 'checkIfHasNothingAvailable', params: ({ event }) => event.output },
          },
          {
            target: 'conflictsWarning',
            actions: [{ type: 'storeConflicts', params: ({ event }) => event.output }],
            guard: { type: 'checkIfHasConflicts', params: ({ event }) => event.output },
          },
          {
            target: 'dismissed',
            actions: ['trackHandoffSuccess', 'replaceWithBag'],
          },
        ],
      },
    },
    activeBagWarning: {
      entry: ['trackActiveBagWarning'],
      on: {
        TRIGGER_HANDOFF: 'cartHandoff',
        DISMISS_HANDOFF: {
          target: 'dismissed',
          actions: ['dismissToHome'],
        },
      },
    },
    conflictsWarning: {
      entry: ['trackConflictsWarning'],
      on: {
        TRIGGER_HANDOFF: { actions: ['setIgnoreConflicts'], target: 'cartHandoff' },
        DISMISS_HANDOFF: {
          target: 'dismissed',
          actions: ['dismissToHome'],
        },
      },
    },
    nothingAvailable: {
      entry: ['trackNothingAvailable'],
      on: {
        DISMISS_HANDOFF: {
          target: 'dismissed',
          actions: ['dismissToHome'],
        },
      },
    },
    dismissed: {},
  },
});
